module.exports = __webpack_public_path__ + "static/img/healthy-life_icon-25.9b6c8af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/genestesting/healthy-life_icon-25.png
// module id = iyrg
// module chunks = 0